import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CSSModules from "react-css-modules";
import Tabs from "components/common/material/Tabs";
import Tab from "components/common/material/Tab";
import { replace } from "react-router-redux";
import _get from "utils/get";
import { FormattedMessage } from "react-intl";
import CardStatement from "./CardStatement";
import CardMakeAPayment from "./CardMakeAPayment";
import CardAutoPaySettings from './CardAutoPaySettings';
import { trackEvent } from "../reducers/analyticsReducer";
import styles from "./CardContainer.scss";
import { Accordion } from '../components/common/Accordion';
import IncomeHousingSettings from "./IncomeHousingSettings/IncomeHousingSettings";
import AtpUpdateBanner from "../card/CardDialogs/AtpUpdateBanner/AtpUpdateBanner";
import {getAtpBannerUTMQueryParams, getAtpDetails, getCardCustomerId,} from "./cardHelper";
import {MixPanelAtpSteps, MixPanelEvents, utmBannerParams} from "../constants/mixpanel";
import {ATP_BANNER_LIMIT_KEY, FALSE, TRUE} from '../constants/session-constants';
import * as cardActions from "./redux";
import {datadogRum} from "@datadog/browser-rum";
import * as thunkActionHelpers from '../utils/redux/thunkActionHelpers';
import configService from "services/config";
import cardPlasticImage from "./public/cardPlasticImage.png";

const TAB_NAMES = [
  "statement",
  'payment',
  'cardSettings'
];

const SETTINGS_ITEMS = [
  'payment-settings',
  'income-housing'
];

const BANNER_REDIRECT_URL = `/card/cardSettings/income-housing?${getAtpBannerUTMQueryParams()}`;

@connect(
  (state) => ({
    card: state.card,
    queryParams: state.routing.locationBeforeTransitions.query,
    user: state.auth.user,
  }),
  dispatch => ({
    redirect: path => dispatch(replace(path)),
    trackEvent: (event, properties) => dispatch(trackEvent(event, properties)),
    getSunbitCard: ()=> dispatch(cardActions.getSunbitCard(true)),
  })
)
@CSSModules(styles, { allowMultiple: true })
class CardContainer extends React.Component {
  static propTypes = {
    routeParams: PropTypes.object,
    redirect: PropTypes.func,
    trackEvent: PropTypes.func,
    getSunbitCard: PropTypes.func,
    card: PropTypes.object,
    user: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.innerPageRedirect = this.innerPageRedirect.bind(this);
    this.state = {
      isAtpUpdateNeeded:false,
      isAtpBannerOpen:false,
      cardImageUri: '',
      isCardImageUriLoaded: false,
    };
  }

  componentDidMount() {
    this.props.getSunbitCard();
  }


  isFetchStatusSuccess(props) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      cardActions.FETCH_STATUS,
      props.card.type,
      props.card.status
    );
  }


  isFetchStatusFailed(props) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      cardActions.FETCH_STATUS,
      props.card.type,
      props.card.status
    );
  }

  componentWillReceiveProps(nextProps) {
    if (!this.isFetchStatusSuccess() && this.isFetchStatusSuccess(nextProps)) {
      const cardStatus = nextProps.card.cardStatus;
      const partnerFolder = cardStatus.partnerChainName || 'Sunbit';
      const uri = configService.getItem('mySunbitBrandBaseUrl') + partnerFolder + '/webStatementCard.png';

      this.setState((prevState) => {
        return {
          ...prevState,
          isCardImageUriLoaded: true,
          cardImageUri: uri,
        };
      });
    }

    if (!this.isFetchStatusFailed() && this.isFetchStatusFailed(nextProps)) {
      datadogRum.addUserAction('Failed to fetch sunbit card', {customerId: this.props.user.id, error: nextProps.card.error});
      this.setState((prevState) => {
        return {
          ...prevState,
          cardImageUri: cardPlasticImage,
          isCardImageUriLoaded: true,
        };
      });
    }
  }

  innerPageRedirect(redirectPath){
    this.props.redirect(redirectPath);
  }

  closeAtpBanner(){
    this.setState((prevState) => ({...prevState, isAtpBannerOpen:false}));
  }

  componentDidUpdate(prevProps) {
    if(!getAtpDetails(prevProps)  &&  getAtpDetails(this.props)){
      this.setState((prevState) => ({...prevState, isAtpUpdateNeeded:this.props.card.card.isAtpUpdateNeeded}));
    }
    if(this.state.isAtpUpdateNeeded && this.getSettingsItem() === 1){
      this.setState((prevState) => ({...prevState, isAtpUpdateNeeded:false}));

    }
  }

  getActiveTabName() {
    return _get(this, ["props", "routeParams", "activeTab"], "lobby");
  }
    getSettingsItem(){
      const item = _get(this, ["props", "routeParams", "subTab"], null);
      return SETTINGS_ITEMS.indexOf(item);
    }
  getActiveTabIndex() {
    let tabName = this.getActiveTabName();
    let tabIndex = TAB_NAMES.indexOf(tabName);
    if (tabIndex >= 0) {
      return tabIndex;
    } else {
      () => this.innerPageRedirect("/statement");
      return 0;
    }
  }

  getUserFirstName(){
    const userData =  localStorage.getItem("user");
    const userDetailsObj = userData ? JSON.parse(localStorage.getItem("user")) : {};
    return userDetailsObj.firstName || '';
  }

  onCardChange() {
    // TODO
  }

  handleBannerClick(){
    const baseAtpProperties = {...utmBannerParams, customerId: getCardCustomerId(this.props)};
    this.props.trackEvent(MixPanelEvents.atpUpdate, {...baseAtpProperties,step:MixPanelAtpSteps.bannerClicked})
    this.innerPageRedirect(BANNER_REDIRECT_URL);
    this.closeAtpBanner();
}
  getAndHandleIsBAtpBannerShow(){
    // index of 1 indicate  that the atp update accordion item  is already open
    // ATP_BANNER_LIMIT_KEY indicates the session condition (if user just perform login)
    // isAtpUpdateNeeded is a flag from BE according to business logic (see SBT-9418)
    const isBannerNeedToShow =  this.state.isAtpUpdateNeeded && this.getSettingsItem() !== 1 && localStorage.getItem(ATP_BANNER_LIMIT_KEY) === TRUE;
    if(isBannerNeedToShow) {
      this.setState((prevState) => ({...prevState, isAtpBannerOpen:true}));
      localStorage.setItem(ATP_BANNER_LIMIT_KEY, FALSE);
    }
  }

  render() {
    return (
      <div>
        <header styleName="header">
          <h1 styleName="heading">
            <FormattedMessage id="card.label.heading" data-at="card-title" />
          </h1>
        </header>
        <AtpUpdateBanner isOpen={ this.state.isAtpBannerOpen || this.getAndHandleIsBAtpBannerShow.apply(this)} firstName={this.getUserFirstName()} onCloseBanner={this.closeAtpBanner.bind(this)}
                         onApplyClick={this.handleBannerClick.bind(this)} />
        <div styleName="purchaseCard" data-at="card-container">
          <Tabs
            theme={styles}
            inverse={true}
            index={this.getActiveTabIndex(this.props)}
            onChange={this.onCardChange}>
            <Tab
              label={"Statements & Activity"}
              onClick={() => this.innerPageRedirect("/card/statement/last")}
              styleName="tabButton statement"
              data-at="statement-tab">
              <CardStatement routeParams={this.props.routeParams}
                             isCardImageUriLoaded={this.state.isCardImageUriLoaded}
                             cardImageUri={this.state.cardImageUri}/>
            </Tab>
            <Tab
              label="Make a Payment"
              onClick={() => this.innerPageRedirect("/card/payment")}
              styleName="tabButton makeAPayment"
              data-at="payment-tab">
              <CardMakeAPayment routeParams={this.props.routeParams} />
            </Tab>
            <Tab
              label="Settings"
              onClick={()=>this.innerPageRedirect("/card/cardSettings")}
              styleName="tabButton cardSettings settingsLabel"
              data-at="card-settings-tab">
            <Accordion openItem = {this.getSettingsItem()} onClickMiddleware = { (item, onClick) => (index) => {
              // if index is not valid then accordion itm  is closing
                this.innerPageRedirect(`/card/cardSettings/${index >= 0 ? item : ''}`);
                onClick(index);
            }} items={[{title:'Payment Settings',path :SETTINGS_ITEMS[0] ,component: CardAutoPaySettings},{title:'Income & Housing',path :SETTINGS_ITEMS[1], component:IncomeHousingSettings}]}>
           </Accordion>
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

export default CardContainer;



// WEBPACK FOOTER //
// ./src/card/CardContainer.js